import React, { Component, Fragment } from "react";
import "./Site.css";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  Alert as Alert2,
  ButtonGroup,
  Badge
} from "reactstrap";
import moment from "moment";
import Alert from "react-s-alert";
import ToggleButton from 'react-toggle-button';
import _ from "lodash";
import './Site.css';
import { api, stringHelper, uiHelper, constant } from "../helpers";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { Link, Redirect } from "react-router-dom";
import { Schedule } from "../components";

const getEquipmentStatuses = () => api.fetch('Reference/EquipmentStatus').then(response => {
  return {
    equipmentStatusList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));

const getEquipments = () => api.fetch('Equipment/CalibrationEquipments').then(response => {
  return {
    equipmentList: _.map(response.data, x => { return { ...x, value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));

const getCalibrationTypes = () => api.fetch('Reference/CalibrationTypes').then(response => {
  return {
    calibrationTypeList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));

const getCalibrationFrequencies = () => api.fetch('Reference/CalibrationFrequencies').then(response => {
  return {
    calibrationFrequencyList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));

const getTestingMethods = () => api.fetch('Reference/TestingMethods').then(response => {
  return {
    testingMethodList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));

const emptyCalibrationRecord = () => {
  return {
    id: -1,
    calibrationDate: null,
    equipment: null,
    equipmentStatus: null,
    vendorMechanic: null,
    testingMethod: null,
    calibrationFrequency: null,
    foundCalibrationValue: '',
    calibrationResult: '',
    correctiveAction: '',
    passed: false,
    nextScheduledCalibrationDate: null,
    scheduledMaintenance: null,
    scheduledMaintenanceId: null,
    scheduledWorkId: null
  };
}

export default class EditCalibrationRecord extends Component {
  static displayName = EditCalibrationRecord.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      loading: true,
      calibrationRecordId: props.match && props.match.params && props.match.params.id
        ? props.match.params.id
        : null,
      editCalibrationRecord: null,
      equipmentStatusList: [],
      vendorMechanicList: [],
      equipmentList: [],
      redirect: false,
      missingVendor: false,
      equipmentId: this.props.location.state && this.props.location.state.equipmentId
        ? this.props.location.state.equipmentId
        : null,
      scheduledWorkId: this.props.location.state && this.props.location.state.scheduledWorkId
        ? this.props.location.state.scheduledWorkId
        : null,
      viewOnly:
        this.props.location.state && this.props.location.state.viewOnly
          ? this.props.location.state.viewOnly
          : false,
    };

    this.loadCalibrationRecord = this.loadCalibrationRecord.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
    this.getVendorMechanics = this.getVendorMechanics.bind(this);
    this.getEquipment = this.getEquipment.bind(this);
    this.clearValue = this.clearValue.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.deleteScheduledWork = this.deleteScheduledWork.bind(this);
  }

  componentDidMount() {
    Promise.all([getEquipments(), getEquipmentStatuses(), getCalibrationTypes(), getCalibrationFrequencies(),
    getTestingMethods()]).then(response => {
      let newStatus = {};
      _.each(response, r => Object.assign(newStatus, r));
      this.setState(newStatus, () => { this.loadCalibrationRecord(); });
    });
  }

  loadCalibrationRecord() {
    if (this.state.calibrationRecordId === "new") {
      let newRecord = emptyCalibrationRecord();
      if (this.state.equipmentId !== null) {
        newRecord.equipment = stringHelper.resolveValueFromList(this.state.equipmentList, this.state.equipmentId)
        newRecord.scheduledWorkId = this.state.scheduledWorkId !== null ? this.state.scheduledWorkId : null;
      }
      this.setState({ editCalibrationRecord: newRecord, loading: false }, () => {
        if (this.state.equipmentId !== null) {
          this.getVendorMechanics(newRecord.equipment.vendorId);
        }
      });
    } else {
      api.post("Equipment/GetCalibrationRecord", this.state.calibrationRecordId)
        .then(response => {
          if (response.data) {
            var calibrationRecord = response.data;
            calibrationRecord.equipmentStatus = stringHelper.resolveValueFromList(this.state.equipmentStatusList, calibrationRecord.equipmentStatusId);
            calibrationRecord.equipment = stringHelper.resolveValueFromList(this.state.equipmentList, calibrationRecord.equipmentId);
            calibrationRecord.vendorMechanic = { label: calibrationRecord.vendorMechanicName, value: calibrationRecord.vendorMechanicId };
            calibrationRecord.calibrationDate = moment(calibrationRecord.calibrationDate).toDate();
            calibrationRecord.nextScheduledMaintenanceDate = null;
            this.setState({
              editCalibrationRecord: calibrationRecord,
              loading: false,
            }, () => {
                  this.getVendorMechanics(calibrationRecord.vendorId);
            });
          }
        })
    }
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null,
    });
  }

  getVendorMechanics(vendorId) {
    if (vendorId !== null) {
    //var id = vendorId !== null ? parseInt(vendorId, 10) : null
      api.post('Reference/MechanicsByVendor', parseInt(vendorId, 10))
        .then(response => {
          if (response.data) {
            this.setState({
              vendorMechanicList: _.map(response.data, x => {
                return { ...x, value: x.id, label: x.name }
              }),
              missingVendor: false,
            }, () => this.onDismiss());
          }
        }).catch(x => console.error(x));
    } else {
      this.setState({
        isMessageVisible: !this.state.isMessageVisible,
        message: "There is no vendor associated with this equipment. Please go to equipment details and add a default vendor.",
        messageColor: "warning",
        missingVendor: true
      })
    }
  }

  getEquipment(equipmentId) {
    api.post('Equipment/GetEquipment', parseInt(equipmentId, 10))
      .then(response => {
        if (response.data) {
          this.setState({
            editCalibrationRecord: { ...this.state.editCalibrationRecord, equipment: response.data }
          });
        }
      }).catch(x => console.error(x));
  }

  onToggleButtonChange(value, fieldName) {
    this.setState({
      editCalibrationRecord: {
        ...this.state.editCalibrationRecord,
        [fieldName]: !this.state.editCalibrationRecord[fieldName]
      }
    });
  }

  onInputChange(e, fieldName) {
    this.setState({
      editCalibrationRecord: { ...this.state.editCalibrationRecord, [fieldName]: e.target.value }
    })
  }

  onDateChange(date, fieldName) {
    this.setState({
      editCalibrationRecord: { ...this.state.editCalibrationRecord, [fieldName]: date }
    })
  }

  onSelectChange(selection, fieldName) {
    let calibrationRecord = Object.assign({}, this.state.editCalibrationRecord);
    calibrationRecord[fieldName] = selection;
    this.setState({
      editCalibrationRecord: calibrationRecord
    }, () => {
        if (fieldName === "equipment") {
          this.getVendorMechanics(selection.vendorId);
      }
    });
  }

  onEdit() {
    this.setState({ viewOnly: false })
  }

  onCancel() {
    this.setState({
      editCalibrationRecord: null
    });
  }

  isFormValid() {
    let warnings = [];
    if (!this.state.editCalibrationRecord.calibrationDate) {
      warnings.push("Please select an calibration date");
    }
    if (!this.state.editCalibrationRecord.equipment) {
      warnings.push("Please select an equipment");
    }
    if (!this.state.editCalibrationRecord.vendorMechanic) {
      warnings.push("Please select a mechanic");
    }
    if (this.state.editCalibrationRecord.calibrationResult === '') {
      warnings.push("Please enter calibration result");
    }
    if (this.state.editCalibrationRecord.equipment
      && this.state.editCalibrationRecord.equipment.calibrationTypeName
      && (this.state.editCalibrationRecord.equipment.calibrationTypeName !== null
      || this.state.editCalibrationRecord.equipment.calibrationTypeName !== '')
      && this.state.editCalibrationRecord.equipment.calibrationTypeName === constant.calibrationType.range  
      && this.state.editCalibrationRecord.foundCalibrationValue === '') {
      warnings.push("Please enter found calibration value");
    }

    this.setState({ message: (warnings.length ? warnings.join(", ") : null), messageColor: "danger", isMessageVisible: true });
    return warnings.length === 0;
  }

  onSave() {
    if (!this.isFormValid()) return;
    let calibrationRecord = Object.assign({}, this.state.editCalibrationRecord);
    let payload = {
      Id: calibrationRecord.id,
      EquipmentId: calibrationRecord.equipment ? parseInt(calibrationRecord.equipment.value, 10) : null,
      //TestingMethodId: calibrationRecord.equipment.testingMethodId ? parseInt(calibrationRecord.equipment.testingMethodId, 10) : null,
      CalibrationFrequencyId: calibrationRecord.equipment.calibrationFrequencyId ? parseInt(calibrationRecord.equipment.calibrationFrequencyId, 10) : null,
      FoundCalibrationValue: calibrationRecord.foundCalibrationValue !== "" ? parseFloat(calibrationRecord.foundCalibrationValue) : null,
      CalibrationResult: calibrationRecord.calibrationResult,
      CalibrationDate: calibrationRecord.calibrationDate,
      VendorMechanicId: calibrationRecord.vendorMechanic ? parseInt(calibrationRecord.vendorMechanic.value, 10) : null,
      NextScheduledCalibrationDate: calibrationRecord.nextScheduledCalibrationDate,
      Passed: calibrationRecord.passed,
      ScheduledWorkId: calibrationRecord.scheduledWorkId ? calibrationRecord.scheduledWorkId : null,
    }
    if (calibrationRecord.equipment.testingMethodId) {
      payload.TestingMethodId = parseInt(calibrationRecord.equipment.testingMethodId, 10)
    }
    api.post("Equipment/SaveCalibrationRecord", payload)
      .then(response => {
        if (response.data.success) {
          Alert.success("Calibration record has been saved. You will be redirected momentarily.");
          this.timer = setTimeout(() => {
            this.setState({ redirect: true });
          }, 3000);
        } else {
          Alert.error("An error occured saving equipment calibration details.")
        }
      }).catch(x => {
        Alert.error("An error occured saving equipment calibration details.")
      });
  }

  clearValue() {
    this.setState({
      editCalibrationRecord: {...this.state.editCalibrationRecord, equipment: null}
    })
  }


  deleteScheduledWork(scheduledWorkId) {
    if (!window.confirm(`Are you sure you'd like to the scheduled maintenance for this equipment?`)) return;

    api.delete(`Equipment/DeleteScheduledWork/${scheduledWorkId}`)
      .then(response => {
        if (response.data.success) {
          Alert.success("Scheduled maintenance was deleted for this equipment.")
          this.loadCalibrationRecord();
        } else {
          Alert.error("An error occurred. Scheduled maintenance cannot be deleted at this time.")
        }
      }).catch(error => {
        Alert.error("There was an error deleting the scheduled maintenance for this equipment.")
      });
  }
  render() {
    if (this.state.redirect) {
      return <Redirect to={`/equipment_calibration_records`} />;
    }
    const {
      message,
      messageColor,
      editCalibrationRecord,
      viewOnly,
      missingVendor
    } = this.state;
    return (
      <div className="ml-4 mr-4">
        {editCalibrationRecord &&
          <React.Fragment>
            <Row className="mb-2">
              <Col><h5>{editCalibrationRecord.id < 0 ? "New" : ""} Calibration Record</h5></Col>
              {viewOnly ? null :
                <Col>
                  <ButtonGroup className="float-right">
                    <Button size="sm" className="cbdmdSecondary buttonGroupSpacing" onClick={() => this.onCancel()} tag={Link}
                      to={{
                        pathname: "/equipment_calibration_records",
                        push: true,
                      }}
                    >Cancel</Button>
                  <Button size="sm" className="cbdmdPrimary buttonGroupSpacing" onClick={() => this.onSave()} disabled={missingVendor}>{editCalibrationRecord.id > 0 ? "Update" : "Save"}</Button>
                  </ButtonGroup>
                </Col>
              }
            </Row>

            {this.state.message ? (
              <Alert2 color={messageColor} toggle={() => this.onDismiss()}>{message}</Alert2>
            ) : null}

            <Card className="p-2">
              <CardBody>
              {editCalibrationRecord &&
                <Fragment>
                  {
                  editCalibrationRecord.equipment &&
                    <Row className="">
                      <Col className="float-right">
                      <Badge className="fontSize18" color={uiHelper.resolveStatusColor(editCalibrationRecord.equipment.equipmentStatusName)}>{editCalibrationRecord.equipment.equipmentStatusName}</Badge>
                      </Col>
                    </Row>
                  }

                  <Row>
                    <Col className="p-2" title="Details">
                      <Row className="mb-2">
                      <Col>Equipment:
                        {/*<EquipmentTypeahead
                          onChange={(e) => this.onSelectChange(e, "equipment")}
                          value={editCalibrationRecord.equipment}
                          calibrationOnly={true}
                          disabled={this.state.viewOnly || editCalibrationRecord.id > 0}
                        />*/}
                        <Select
                            closeMenuOnSelect={true}
                            value={editCalibrationRecord.equipment}
                            options={this.state.equipmentList}
                            onChange={(e) => this.onSelectChange(e, "equipment")}
                            isDisabled={this.state.viewOnly || editCalibrationRecord.id > 0}
                          />
                        </Col>
                        <Col>Mechanic:
                        <Select
                            closeMenuOnSelect={true}
                            value={editCalibrationRecord.vendorMechanic}
                            options={this.state.vendorMechanicList}
                            onChange={(e) => this.onSelectChange(e, "vendorMechanic")}
                            isDisabled={!editCalibrationRecord.equipment || missingVendor}
                          />
                        </Col>
                        <Col>Date:
                      <div>
                            <DatePicker
                          selected={editCalibrationRecord.calibrationDate}
                          className="form-control pageTitleItem float-right"
                          placeholderText="Select a date performed"
                          onChange={(e) => this.onDateChange(e, "calibrationDate")}
                          disabled={missingVendor}
                            />
                          </div>
                        </Col>
                      </Row>

                    {editCalibrationRecord && editCalibrationRecord.equipment && !missingVendor &&
                      <Fragment>
                        <Row className="mb-2">
                          <Col>Reference Code:
                            <Input type="text" name="referenceCode" id="referenceCode" value={editCalibrationRecord.equipment.referenceCode} disabled />
                          </Col>
                          <Col>Serial Number:
                            <Input type="text" name="serialNumber" id="serialNumber" value={editCalibrationRecord.equipment.serialNumber} disabled />
                          </Col>
                          <Col>Model Number:
                            <Input type="text" name="modelNumber" id="modelNumber" value={editCalibrationRecord.equipment.modelNumber} disabled />
                          </Col>
                        </Row>

                        <Row className="mb-2">
                          <Col>Testing Method:
                            <Input type="text" name="testingMethodName" id="testingMethodName" value={editCalibrationRecord.equipment.testingMethodName || "N/A"} disabled />
                          </Col>
                          <Col>Beginning Range:
                            <Input type="text" name="beginningCalibrationRange" id="beginningCalibrationRange" value={editCalibrationRecord.equipment.beginningCalibrationRange || "N/A"} disabled />
                          </Col>
                          <Col>Ending Range:
                            <Input type="text" name="endingCalibrationRange" id="endingCalibrationRange" value={editCalibrationRecord.equipment.endingCalibrationRange || "N/A"} disabled />
                          </Col>
                        </Row>

                    <Row className="">
                      {editCalibrationRecord.equipment &&
                        <Col>Calibration Description:
                            <Input
                              type="textarea"
                              name="calibrationDescription"
                              id="calibrationDescription"
                            value={editCalibrationRecord.equipment.calibrationDescription || "N/A"}
                            disabled={true} />
                        </Col>
                      }
                        <Col>Calibration Results:
                          <Input
                            type="textarea"
                            maxLength="500"
                            name="calibrationResult"
                            id="calibrationResult"
                            onChange={(e) => this.onInputChange(e, 'calibrationResult')} value={editCalibrationRecord.calibrationResult} disabled={this.state.viewOnly} />
                      </Col>
                      <Col xs="3">
                      <Row>
                            {editCalibrationRecord.equipment && editCalibrationRecord.equipment.calibrationTypeName === "Range" &&
                            <Col>Found Calibration Value:
                              <Input type="number" step="0.01" placeholder="0.0" name="foundCalibrationValue" id="foundCalibrationValue"
                                onChange={(e) => this.onInputChange(e, 'foundCalibrationValue')} value={editCalibrationRecord.foundCalibrationValue} />
                            </Col>
                          }
                      <Col>  
                      Passed:
                      <ToggleButton
                        value={editCalibrationRecord.passed}
                        activeLabel={"Yes"}
                        inactiveLabel={"No"}
                        onToggle={(value) => {
                          this.onToggleButtonChange(value, "passed")
                        }}
                      />
                        </Col>
                      </Row>
                    </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col xs="3">
                          <Schedule
                            scheduledMaintenance={editCalibrationRecord.scheduledMaintenance}
                            deleteScheduledWork={this.deleteScheduledWork}
                            onDateChange={this.onDateChange}
                            nextScheduledDate={editCalibrationRecord.nextScheduledCalibrationDate}
                            title={constant.maintenanceType.Calibration.name}
                          />
                        </Col>
                      </Row>
                    </Fragment>
                  }
                    </Col>
                </Row>
                  </Fragment>
                }
              </CardBody>
            </Card>

          </React.Fragment>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/EditCalibrationRecord.js